import Mustache from 'mustache';
import {
    displayErrorFeedbackMessage,
    displaySuccessFeedbackMessage,
    getTranslation
} from './utilities';
import CartClient from './clients/CartClient';
import OrderClient from './clients/OrderClient';
import ShoppinglistTablesOverlay from './shoppinglists-tables-overlay';
import MediaLibrarySearchLink from './media-library/search-link';
import createAboPaths from './abo-paths';

class Orders
{
    constructor()
    {
        this.ordersClient = new OrderClient();
        this.cartClient = new CartClient();
        this.shoppinglistTablesOverlay = new ShoppinglistTablesOverlay();
        this.mediaLibrarySearchLink = new MediaLibrarySearchLink();

        this.data = [];

        this.table = undefined;
        this.itemTables = {};
        this.childRows = null;
        this.selectedRows = {};

        this.$itemTableTemplate = $('#ordersItemTable').clone(true);

        this.listTemplate = document.querySelector('#ordersListTemplate').innerHTML;
        this.itemElementTemplate = document.querySelector('#ordersItemElementTemplate').innerHTML;

        this.selector = '.js-orders';
        this.itemSelector = '.js-orders__item';
        this.deleteButtonSelector = '.js-orders__delete-list';
        this.addToCartButtonSelector = '.js-orders__add-to-cart';
        this.reorderButtonSelector = '.js-orders__reorder';
        this.shoppinglistButtonSelector = '.js-orders__shoppinglist';

        this.orderIdMeta = {
            1: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.open'),
                showEditCancelButton: true,
                showReorderButton: false
            },
            2: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.open'),
                showEditCancelButton: true,
                showReorderButton: false
            },
            3: {
                class: 'storno-status',
                icon: 'fa-circle-xmark',
                text: getTranslation('content.orderlist.status.canceled'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            4: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.open'),
                showEditCancelButton: true,
                showReorderButton: false
            },
            5: {
                class: 'open-status',
                icon: 'fa-check',
                text: getTranslation('content.orderlist.status.done'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            6: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.open'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            7: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.open.read.only'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            8: {
                class: 'storno-status',
                icon: 'fa-circle-xmark',
                text: getTranslation('content.orderlist.status.canceled.erp'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            9: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.invoiced.partially'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            10: {
                class: 'closed-status',
                icon: 'fa-check',
                text: getTranslation('content.orderlist.status.invoiced'),
                showEditCancelButton: false,
                showReorderButton: true
            },
            11: {
                class: 'open-status',
                icon: 'fa-hourglass',
                text: getTranslation('content.orderlist.status.migrated'),
                showEditCancelButton: false,
                showReorderButton: true
            },
        };
    }

    init()
    {
        this.table = $(this.selector).DataTable({
            ajax: {
                url: this.ordersClient.uri,
                dataSrc: (json) =>
                {
                    for (let i = 0; i < json[this.ordersClient.dataSrc].length; i++)
                    {
                        let { orderStatusId } = json[this.ordersClient.dataSrc][i];

                        json[this.ordersClient.dataSrc][i].showEditCancelButton =
							this.orderIdMeta[orderStatusId].showEditCancelButton;

                        json[this.ordersClient.dataSrc][i].showReorderButton =
							this.orderIdMeta[orderStatusId].showReorderButton;

                        json[this.ordersClient.dataSrc][i].orderStatusClass =
							this.orderIdMeta[orderStatusId].class;

                        json[this.ordersClient.dataSrc][i].orderStatusIcon =
							this.orderIdMeta[orderStatusId].icon;

                        json[this.ordersClient.dataSrc][i].orderStatusText =
							this.orderIdMeta[orderStatusId].text;

                        json[this.ordersClient.dataSrc][i].isAcceptedFixedPriceOffer = false;

                        if (json[this.ordersClient.dataSrc][i].attributes &&
                            json[this.ordersClient.dataSrc][i].attributes['accepted_fixed_price_offer']
                        )
                        {
                            json[this.ordersClient.dataSrc][i].isAcceptedFixedPriceOffer = true;
                        }

                        let { orderTimestamp } = json[this.ordersClient.dataSrc][i];

                        json[this.ordersClient.dataSrc][i].orderDate =
                            new Date(orderTimestamp * 1000).toLocaleDateString(
                                orion.getLocaleCode().replace('_', '-'),
                                { day: '2-digit', month: '2-digit', year: 'numeric' }
                            );
                    }

                    return json[this.ordersClient.dataSrc];
                }
            },
            pageLength: 20,
            searching: false,
            lengthChange: false,
            language: this.datatableTexts(),
            order: [[1, 'desc']],
            columnDefs: [
                {
                    targets: 0,
                    orderable: false,
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.listTemplate, { orderList: row });
                    }.bind(this)
                },
                // define hidden timestamp column just for ordering
                {
                    targets: 1,
                    data: 'orderTimestamp',
                    visible: false
                }
            ],
            drawCallback: function()
            {
                if (this.childRows)
                {
                    this.childRows.every(function()
                    {
                        this.nodes().to$()
                            .click();
                    });

                    // Reset childRows so loop is not executed each draw
                    this.childRows = null;
                }

                $('#orders thead').hide();
                $('#ordersItemTable thead').hide();
                this.initEvents();
            }.bind(this),
            createdRow: function(row, data)
            {
                let $row = $(row);

                $row.attr('data-order-id', data.orderId);
                $row.attr('data-order-reference', data.orionOrderReference);
                $row.addClass('orders-list__item js-orders__item dt--shadow dt--shadow-mobile');

                if (data.orderStatusId >= 4 && data.orderStatusId <= 6)
                {
                    $row.addClass('open-status');
                }
                else if (data.orderStatusId == 3 || data.orderStatusId == 8)
                {
                    $row.addClass('storno-status');
                }
                else if (data.orderStatusId == 10)
                {
                    $row.addClass('closed-status');
                }
                else
                {
                    $row.addClass('open-status');
                }
            }
        });

        this.shoppinglistTablesOverlay.init();
    }

    initEvents()
    {
        let self = this;

        $(this.deleteButtonSelector).off('click');
        $(this.deleteButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            self.showOverlay(data, $('#overlay-cancel-order'));
        });

        $(this.addToCartButtonSelector).off('click');
        $(this.addToCartButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            let cartQuantity = $('#basket-onsite').data('cart-quantity');

            if (cartQuantity === 0)
            {
                self.showOverlay(data, $('#overlay-edit-order-cart-empty'));
            }
            else
            {
                self.showOverlay(data, $('#overlay-edit-order-cart-filled'));
            }
        });

        $(this.reorderButtonSelector).off('click');
        $(this.reorderButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            let cartQuantity = $('#basket-onsite').data('cart-quantity');

            if (cartQuantity === 0)
            {
                self.handleAddListToCartClick(data, true);
            }
            else
            {
                self.showOverlay(data, $('#overlay-reorder-order-cart-filled'), true);
            }
        });

        $(this.shoppinglistButtonSelector).off('click');
        $(this.shoppinglistButtonSelector).on('click', function()
        {
            let $tr = $(this);
            let row = self.table.row($tr.parents(self.itemSelector));
            let data = row.data();

            self.ordersClient.fetchAllItems(data.orderId)
                .then((response) => response.json())
                .then((json) =>
                {
                    self.shoppinglistTablesOverlay.initOverlay(json);
                });
        });

        $(this.selector).off('click');
        $(this.selector).on('click', this.itemSelector, function(e)
        {
            let $tr = $(this);
            let row = self.table.row($tr);
            let data = row.data();

            self.handleItemClick(e, $tr, row, data);
        });
    }

    handleItemClick(e, $tr, row, data)
    {
        if (e === null
			|| !$(e.target).hasClass('js-do-not-toggle-list')
			&& !$(e.target).parents('.js-do-not-toggle-list').length
        )
        {
            this.toggleDetail($tr, row, data);
            this.childRows = this.table.rows($('.shown'));
        }
    }

    datatableTexts()
    {
        return {
            'paginate': {
                'previous': '<i class="fa-regular fa-chevron-left"></i>',
                'next': '<i class="fa-regular fa-chevron-right"></i>',
            },
            'processing': getTranslation('content.orderlist.processing'),
            'loadingRecords': getTranslation('content.orders.loading'),
            'info': getTranslation('content.orders.info.entries'),
            'infoEmpty': getTranslation('content.orders.info.entries.empty'),
            'emptyTable': getTranslation('content.orders.info.list.empty'),
            'select': {
                'rows': {
                    _: '(%d) '
						+ getTranslation('content.orders.info.selected.article'),
                },
            }
        };
    }

    initChildEvents()
    {
        // ...
    }

    formatOrder(self, order)
    {
        $(order).each(function(k)
        {
            order[k].field = self.matchOrderIdWithColumnName(order[k].column);
        });

        return order;
    }

    matchOrderIdWithColumnName(orderId)
    {
        switch (orderId)
        {
        case 0:
            return 'productNumber';
        case 1:
            return 'productName';
        case 2:
            return 'undiscountedPrice';
        case 3:
            return 'discountedPrice';
        case 4:
            return 'quantity';
        case 5:
            return 'subtotalPrice';
        default:
            return null;
        }
    }

    createChildTable(row, ordersId)
    {
        let self = this;
        let template = this.$itemTableTemplate.clone(true);

        row.child(template).show();

        let itemTable = template.DataTable({
            ajax: {
                url: this.ordersClient.uri + '/' + ordersId + '/items',
                data: function(data)
                {
                    return {
                        skip: data.start,
                        take: data.length,
                        sort: self.formatOrder(self, data.order)// data.order
                    };
                },
                dataSrc: function(json)
                {
                    return json.orderListItems.map((orderListItem) =>
                    {
                        const originalSrc = orderListItem.productImageUrl.trim();
                        const targetSrc = originalSrc.replace('product-main-image', 'product-list-image-thumbnail');

                        const aboPaths = createAboPaths(targetSrc);

                        orderListItem.productImageUrl = aboPaths.original;
                        orderListItem.productImageUrlAvif =
                            aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x';
                        orderListItem.productImageUrlWebp =
                            aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x';
                        orderListItem.productImageUrlJpeg = aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x';

                        orderListItem.expiringProductFlag = orderListItem.expiringProductFlag !== 0;
                        orderListItem.promotionalPackingFlag = orderListItem.promotionalPackingFlag === 0;
                        orderListItem.privateBrandFlag = orderListItem.privateBrandFlag !== 0;
                        orderListItem.posProductFlag = orderListItem.posProductFlag !== '0';

                        orderListItem.isOutOfStock = false;
                        orderListItem.isAvailable = false;

                        if (orderListItem.availability === 0)
                        {
                            orderListItem.isOutOfStock = true;
                        }
                        else if (orderListItem.availability === 1)
                        {
                            orderListItem.isAvailable = true;
                        }

                        return orderListItem;
                    });
                }
            },
            dom: 'l\
				f\
				r\
				<"orders-list-table__scroll table--scroll-mobile"t>\
				<"orders-list__action-wrapper"\
				<"orders-list-actions__selection">\
				<"orders-list-actions__pagination"pi>\
				<"orders-list-actions__basket">>',
            pageLength: 20,
            rowId: 'productNumber',
            serverSide: true,
            processing: true,
            // order: [[2, 'asc']],
            language: this.datatableTexts(),
            searching: false,
            lengthChange: false,
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5],
                    orderable: false
                },
                {
                    // Hidden column to sort for product number
                    // Sort criteria must be mapped to a column
                    // See matchOrderIdWithColumnName(orderId)
                    targets: 0,
                    visible: false,
                    render: function()
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            productNumberColumn: true
                        });
                    }.bind(this)
                },
                {
                    data: null,
                    targets: 1,
                    orderable: false,
                    className: 'orders-list__product-details',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            orderListItem: row,
                            productDetailsColumn: true
                        });
                    }.bind(this),
                    createdCell: function(td, cellData, rowData)
                    {
                        let $availabilityIcon = $(td).find('i.fa-circle');

                        if (rowData.isAvailable)
                        {
                            $availabilityIcon.addClass('in-stock');
                        }
                        else
                        {
                            $availabilityIcon.addClass('out-of-stock');
                        }
                    }
                },
                {
                    width: '15%',
                    targets: 2,
                    className: 'orders-list__lp-sp',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            orderListItem: row,
                            undiscountedPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    width: '12%',
                    targets: 3,
                    className: 'orders-list__price text--bold',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            orderListItem: row,
                            discountedPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    width: '12%',
                    targets: 4,
                    className: 'orders-list__quantity',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            orderListItem: row,
                            ordersId: ordersId,
                            quantityColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    width: '12%',
                    data: 'subtotalPrice',
                    targets: 5,
                    className: 'orders-list__total text--bold',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            orderListItem: row,
                            subtotalPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                }
            ],
            drawCallback: function()
            {
                $('#ordersItemTable thead').show();
                $('#ordersItemTable').eq(0)
                    .hide();

                let $tr = $(this).parents('tr');
                let row = self.table.row($tr.prev());
                let data = row.data();

                $tr.addClass('orders-list__item-table dt--shadow dt--shadow-mobile');

                $('.js-orders__grand-total').remove();
                $tr.find('.dataTables_wrapper').append('<span class="grand-total text--bold p3 js-orders__grand-total">'
					+ getTranslation('content.orderlist.detail.sum')
					+ ' '
					+ data.grandTotalString
					+ '</span>');
            },
            initComplete: function()
            {
                const $tr = $(this).parents('tr');
                const row = self.table.row($tr.prev());
                const data = row.data();

                self.initChildEvents();

                itemTable.buttons().container()
                    .appendTo($(this.api().column(0)
                        .footer()));

                itemTable.buttons('orderlist', null).container()
                    .appendTo($tr.find('.dataTables_wrapper'));

                $('.dataTables_paginate').addClass('orders_pagination');
                self.itemTables[ordersId] = itemTable;

                self.createSortSelection(itemTable, this[0]);

                const $mediaSearchLink = itemTable.button('ml-search-link:name').nodes();
                const $mediaSearchNote = itemTable.button('ml-search-note:name').nodes();
                const mlNoteTooltip = document.querySelector('#ml-search-note-tootip').content.cloneNode(true);

                self.ordersClient.fetchAllItems(data.orderId)
                    .then((response) => response.json())
                    .then((json) =>
                    {
                        const productNumbersString = Object.keys(json).join(',');

                        $mediaSearchLink
                            .attr('href', getTranslation('url.media.library.search')
                                + '?searchTerm=' + productNumbersString)
                            .attr('data-ml-search-value', productNumbersString);

                        $mediaSearchNote[0].insertAdjacentElement('afterend', mlNoteTooltip.firstElementChild);

                        self.mediaLibrarySearchLink.init($mediaSearchLink[0], $mediaSearchNote[0]);
                    });

                $('body').trigger(orion.constants.EventOrderlistItemLoaded);
            }
        });

        new $.fn.dataTable.Buttons(itemTable, {
            name: 'orderlist',
            buttons: [
                {
                    name: 'ml-search-link',
                    text: '<span>'
                        + getTranslation('button.media.from.order.text')
                        + '</span>',
                    className: 'button secondary js-media-library__search-link hidden',
                    attr: {
                        'data-ml-search-field': 'batch',
                        'data-ml-search-value': ''
                    },
                    action: function(_e, _dt, $node)
                    {
                        window.location = $node.attr('href');
                    }
                },
                {
                    name: 'ml-search-note',
                    text: '<span>'
                        + getTranslation('button.media.from.order.text')
                        + '</span>',
                    className: 'js-tooltip-icon button secondary js-media-library__search-note ' +
                        'media-library__search-note hidden disabled',
                },
                {
                    text:  '<i class="fa-regular fa-download"></i> '
						+ '<span>'
						+ getTranslation('form.download-orderlist-as-csv')
						+ '</span>',
                    attr: {
                        'data-orderid': ordersId
                    },
                    className: 'button secondary download-orderlist-as-csv js-download-orderlist-as-csv',
                }
            ]
        });
    }


    createSortSelection(itemTable, currentTable)
    {
        let filterSection = document.createElement('div');
        let sortSelection = document.createElement('select');
        let sortPlaceholder = document.createElement('option');

        filterSection.classList.add('order-list__sort', 'select-button-container');

        sortPlaceholder.value = '';
        sortPlaceholder.text = getTranslation('content.orderlist.child.sort.recent');
        sortPlaceholder.selected;
        sortPlaceholder.disabled;
        sortSelection.appendChild(sortPlaceholder);

        let { 0: columns } = itemTable.columns();

        for (let i = 0; i < columns.length; i++)
        {
            let optionAscending = document.createElement('option');
            let optionDescending = document.createElement('option');

            optionAscending.value = columns[i] !== 0 ? columns[i] : 999;
            optionAscending.text = getTranslation('content.orderlist.child.header.col.' + i) + ' '
                + getTranslation('content.orderlist.child.sort.ascending');
            sortSelection.appendChild(optionAscending);

            optionDescending.value = columns[i] !== 0 ? columns[i] * -1 : -999;
            optionDescending.text = getTranslation('content.orderlist.child.header.col.' + i) + ' '
                + getTranslation('content.orderlist.child.sort.descending');
            sortSelection.appendChild(optionDescending);
        }

        filterSection.append(sortSelection);
        $(filterSection).prependTo($(currentTable).closest('#ordersItemTable_wrapper'));

        sortSelection.addEventListener('change', function()
        {
            if (this.value > 0)
            {
                itemTable.order([this.value != 999 ? this.value : 0, 'asc']).draw();
            }
            else if (this.value < 0)
            {
                itemTable.order([this.value != -999 ? this.value * -1 : 0, 'desc']).draw();
            }
            else
            {
                itemTable.order([0, 'asc']).draw();
            }
        });
    }
    linkToCartAddedItems()
    {
        let linkOderAddedBasket = $('meta[name="link.order.added.basket"]').attr('content');
        window.location.href = linkOderAddedBasket;
    }

    linkToCartReplaceItems()
    {
        let linkOderReplaceBasket = $('meta[name="link.order.replace.basket"]').attr('content');
        window.location.href = linkOderReplaceBasket;
    }

    // etracker datalayer enrichment
    pushOrderCancellationToDatalayer(orderId)
    {
        let row = document.querySelector(`[data-order-id="${orderId}"]`);
        let { orderReference } = row.dataset;

        window.dataLayer.push({
            event: 'orderCancellation',
            cancelTransactionId: orderReference,
        });
    }

    handleCancelOrderClick(data)
    {
        let successMessage = $('#feedback-order-storno-ok').text();

        let promise = this.ordersClient.cancelOrder(data.orderId);

        this.handleRequestPromise(
            promise,
            successMessage,
            '',
            true,
            this.table,
            () =>
            {
                this.handleRequestPromise(
                    this.ordersClient.cancelOrder(data.orderId),
                    '',
                    '',
                    true
                );

                this.pushOrderCancellationToDatalayer(data.orderId);
            }
        );
    }

    handleAddListToCartClick(data)
    {
        let promise = this.ordersClient.addToCart(data.orderId);

        this.handleRequestPromise(
            promise,
            '',
            '',
            false,
            this.table,
            () =>
            {
                this.handleRequestPromise(
                    this.ordersClient.cancelOrder(data.orderId),
                    '',
                    '',
                    true,
                    this.table,
                    () =>
                    {
                        this.pushOrderCancellationToDatalayer(data.orderId);

                        this.linkToCartAddedItems();
                    }
                );
            }
        );
    }

    handleReplaceCartClick(data)
    {
        let promise = this.ordersClient.replaceCart(data.orderId);

        this.handleRequestPromise(
            promise,
            '',
            '',
            false,
            this.table,
            () =>
            {
                this.handleRequestPromise(
                    this.ordersClient.cancelOrder(data.orderId),
                    '',
                    '',
                    true,
                    this.table,
                    () =>
                    {
                        this.pushOrderCancellationToDatalayer(data.orderId);

                        this.linkToCartReplaceItems();
                    }
                );
            }
        );
    }

    /**
	 * @param promise {Promise<Response>}
	 * @param successMessage {string}
	 * @param errorMessage {string}
	 * @param refreshAfterSuccess {boolean}
	 * @param tableRef
	 * @param cb
	 */
    handleRequestPromise(
        promise,
        successMessage,
        errorMessage = '',
        refreshAfterSuccess = false,
        tableRef = this.table,
        cb = null
    )
    {
        promise
            .then(function()
            {
                this.handleErrorRequests(errorMessage);
            }.bind(this))
            .then(function()
            {
                this.handleSuccessfulRequests(successMessage, refreshAfterSuccess, tableRef);
                $('body').trigger(orion.constants.EventCartProductUpdated);

                if (typeof cb === 'function')
                {
                    cb();
                }
            }.bind(this))
            .catch(function(error)
            {
                // eslint-disable-next-line no-console
                console.error(error);
            });
    }

    /**
	 * @param successMessage {string}
	 * @param refreshAfter
	 * @param tableRef
	 */
    handleSuccessfulRequests(successMessage, refreshAfter, tableRef)
    {
        if (successMessage !== '')
        {
            displaySuccessFeedbackMessage(successMessage);
        }
        if (refreshAfter)
        {
            tableRef.ajax.reload(() =>
            {
                this.initEvents();
                this.initChildEvents();
            }, false);
        }
    }

    handleErrorRequests(errorMessage)
    {
        if (errorMessage !== '')
        {
            displayErrorFeedbackMessage(errorMessage);
        }
    }

    showOverlay(data, $overlay, reorder = false)
    {
        $overlay.unbind();
        let $body = $('body');
        $overlay.removeClass('hidden');
        $body.addClass('focus-active');

        $body.on('focus-overlay-clicked', () =>
        {
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.close, .close-overlay', () =>
        {
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.overlay-cancellation', () =>
        {
            this.handleCancelOrderClick(data);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.replace-cart', () =>
        {
            this.handleReplaceCartClick(data, reorder);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.add-to-cart', () =>
        {
            this.handleAddListToCartClick(data, reorder);
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.overlay-edit', () =>
        {
            this.handleAddListToCartClick(data);
            this.hideOverlay($overlay);
        });
    }

    hideOverlay($overlay)
    {
        $overlay.addClass('hidden');
        $('body').removeClass('focus-active');
    }

    destroyChild(row)
    {
        let $table = $('table', row.child());

        $table.detach();
        $table.DataTable().destroy();

        // And then hide the row
        row.child.hide();
    }

    toggleDetail(tr, row, data)
    {
        if (row.child.isShown())
        {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tr.find('.js-expand-list-span').removeClass('open');
        }
        else
        {
            // Open this row
            if (typeof row.child() !== 'undefined')
            {
                row.child.show();
                tr.addClass('shown');
                tr.find('.js-expand-list-span').addClass('open');
            }
            else
            {
                this.createChildTable(row, data.orderId);
                tr.addClass('shown');
                tr.find('.js-expand-list-span').addClass('open');
            }
        }
    }
}

if (document.querySelector('.js-orders') !== null)
{
    (new Orders()).init();
}
